import { SyntheticEvent } from 'react';

export type OriginalEventType = Event | SyntheticEvent | FilterEvent<any, any> | undefined;

/**
 * `VALUE_TYPE` defines the type of the event's value
 * `E` defines the possible types of the original event
 */
export class FilterEvent<T, E extends OriginalEventType> {
    private readonly _value: T | undefined;

    private readonly originalEvent: E | undefined;

    constructor(originalEvent: E | undefined, value?: T) {
        this.originalEvent = originalEvent;
        this._value = value;
    }

    get isFilterEvent(): boolean {
        return true;
    }

    get target(): EventTarget | null {
        const originalEvent = this.originalEvent;

        return originalEvent ? originalEvent.target : null;
    }

    get value(): T | undefined {
        if (this._value !== undefined) {
            return this._value;
        }

        const originalEvent = this.originalEvent as FilterEvent<any, any>;
        if (!originalEvent) {
            return undefined;
        }

        if (originalEvent.isFilterEvent) {
            return originalEvent.value;
        }

        const target = originalEvent.target;
        if (target instanceof HTMLSelectElement
            || target instanceof HTMLInputElement
            || target instanceof HTMLTextAreaElement) {
            return (target.value as unknown) as T;
        } else {
            return undefined;
        }
    }

    get valueAsNumber(): number {
        const value = this.value;
        if (value === undefined || value === null) {
            return NaN;
        }
        if (typeof value === 'string' || value instanceof String) {
            return parseInt('' + value, 10);
        } else if (typeof (value as unknown as object).toString === 'function') {
            return parseInt((value as unknown as object).toString(), 10);
        } else {
            return NaN;
        }
    }
}
